import { Component, type ErrorInfo, type PropsWithChildren } from "react";

type State = { failed: boolean };

export class ErrorBoundary extends Component<PropsWithChildren, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    if (import.meta.env.DEV) console.error("Guiding Stars render error", error, info);
  }

  render() {
    if (this.state.failed) {
      return (
        <main className="fatal-error">
          <p>Guiding Stars</p>
          <h1>The sky could not be opened.</h1>
          <span>Your records have not been changed. Refresh the page to try again.</span>
          <button type="button" onClick={() => window.location.reload()}>
            Refresh
          </button>
        </main>
      );
    }
    return this.props.children;
  }
}
